<template>
    <gofix-card class="equipmentCustomField" classContent="mt-20" classHeader="pl-23 mb-0 text-transform-none" title="Creditor Code">
        <template slot="gofixCard:right_header">
            <gofix-button v-if="!$disabledCreateOrUpdate(this.company, $accessModule.companies)" label=" " @click="showModalCreditorCode" noBorder>
                <template slot="gofix:button:beforeLabel">
                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                        <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                        <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                    </svg>
                </template>
            </gofix-button>
        </template>
        <b-row>
            <template v-for="(item, index) in vendorLinkingCreditorCode">
                <b-col class="mb-3" cols="6" :key="index">
                    <gofix-card title=" " class="h-100 pd-15" classHeader="pt-0 mb-0" classContent="mb-0 pl-0 pr-0">
                        <b-row>
                            <b-col md="9" class="mb-3">
                                <gofix-text-field label="Finance Company" classLabel="width-145" oneline>
                                    {{ item.coa_companie && item.coa_companie.name ? item.coa_companie.name  : null }}
                                </gofix-text-field>
                            </b-col>
                            <b-col md="3" class="mb-15 text-right" v-if="!$disabledCreateOrUpdate(company, $accessModule.companies)">
                                <span class="editBox position-static cursor-pointer mr-12" @click="showModalCreditorCode(item, index)">
                                    <img src="img/iconPencil.png" alt  width="18" height="18"/>
                                </span>
                                <span class="editBox position-static cursor-pointer" @click="confirmRemove(item, index)">
                                    <img src="img/deleteIcon.png" alt  width="20" height="20"/>
                                </span>
                            </b-col>
                            <b-col md="12">
                                <gofix-text-field label="Creditor code" classLabel="width-145" oneline>
                                    {{ item.creditor_code.source_code ? item.creditor_code.source_code : null }} - {{ item.creditor_code.source_description ? item.creditor_code.source_description : null }}
                                </gofix-text-field>
                            </b-col>
                        </b-row>
                    </gofix-card>
                </b-col>
            </template>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open">
            <gofix-form-dropdown 
                class="gofixInputNoMinWidth" 
                label="Finance Company" 
                vLabel="name" 
                v-model="modal.data.coa_companie"
                @change="changeFinanceCompany"
                :options="modal.options.finance_companies" />
            <gofix-form-dropdown 
                class="gofixInputNoMinWidth" 
                label="Creditor Code" 
                vLabel="source_code" 
                :clearable="false"
                :filterable="false" 
                @search="searchCreditorCode"
                v-model="modal.data.creditor_code" 
                :options="modal.options.creditor_codes">
                <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                    <span v-b-tooltip.hover.top :title="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')" v-html="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')"></span>
                </template>
                <template #gofixInput:dropdown:option="option">
                    <span v-b-tooltip.hover.top :title="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')" v-html="(option.source_code  ? option.source_code : '--')+(option.source_description ? (' - ' + option.source_description) : '')"></span>
                </template>
            </gofix-form-dropdown>
            <b-button-group class="d-block text-right">
                <gofix-button label="SAVE" :loading="modal.loading" @click="saveItem" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modalDel.open">
            <div class="center">Are you sure you want to <br/>delete <strong>This Item</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modalDel.open = false">No</b-button>
                <b-button class="custom-btn" :disabled="modalDel.loading" @click="removeItem"> <b-spinner v-if="modalDel.loading" small type="grow"></b-spinner> Yes</b-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>

<script>
    export default {
        name: "equipment-customfield",
        props: {
            organization_id: {
                type: Number,
                default: null
            },
            company: {
                type: Object,
                required: false,
                default: () => null
            },
        },
        data() {
            return {
                vendorLinkingCreditorCode: [],
                modal: {
                    open: false,
                    loading: false,
                    title: 'Add Creditor Code',
                    itemIndex: null,
                    data: {
                        organization_id: this.organization_id,
                        coa_companie: null,
                        coa_companie_id: null,
                        creditor_code: null,
                        erp_mastercode_id: null,
                    },
                    options: {
                        finance_companies: [],
                        creditor_codes: []
                    },
                },
                modalDel: {
                    open: false,
                    loading: false,
                    removeId: null,
                    removeIndex: null,
                    removeIds: [],
                },
                timer: {
                    creditor_code: null
                }
            };
        },
        watch: {
            "modal.data.coa_companie": function(val, old) {
                if(val) {
                    this.loadCreditorCode();
                }
            },
            organization_id: function(val) {
                if(val) {
                    this.getItems();
                }
            }
        },
        async created() {
            if(this.organization_id) this.getItems();
            this.loadFinanceCompanies()
        },
        methods: {
            getItems() {
                this.$store.dispatch(`VendorLinkingCreditorCodeController/getItems`, {
                    limit: -1,
                    page: 1,
                    filter: {
                        organization_id: this.organization_id
                    }
                }).then(response => {
                    this.vendorLinkingCreditorCode = response.data.data.items;
                    this.$emit('updateCreditorCodes', this.vendorLinkingCreditorCode);
                })
                .catch(error => {
                    this.modal.loading = false;
                });
            },
            loadFinanceCompanies(search = null, loading = () => {}){
                loading(true);
                this.$store.dispatch("ChartOfAccountController/getCompanies", {
                    limit: -1,
                    page: 1
                }).then(response => {
                    this.modal.options.finance_companies = response.items;
                    loading(false);
                })
                .catch(err => {
                    loading(false);
                })
            },
            loadCreditorCode(search = null, loading = () => {}){
                this.modal.options.creditor_codes = [];
                if(!this.modal.options.creditor_codes || !this.modal.data.coa_companie.code) return;
                loading(true);
                let filter = {
                    source_type: "S",
                    is_blocked: 0,
                    source_code: search || null,
                    company_code: this.modal.data.coa_companie.code
                };
                let params = {
                  filter: filter,
                  limit: 100,
                  sortColumn: "source_code",
                  sortDirection: "asc",
                };
                this.$store.dispatch(`ERPMasterCodeController/getItems`, params)
                .then(response => {
                    this.modal.options.creditor_codes = response.items;
                    loading(false);
                }).catch(err => {
                    loading(false);
                })
            },
            async searchCreditorCode(search, loading) {
                loading(true);
                this.modal.options.creditor_codes = []
                if (this.timer.creditor_code) {
                    clearTimeout(this.timer.creditor_code);
                    this.timer.creditor_code = null;
                }
                this.timer.creditor_code = setTimeout(async () => {
                    try {
                        await this.loadCreditorCode(search, loading);
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },
            showModalCreditorCode(item = null, index = null) {
                this.modal.options.creditor_codes = [];
                this.modal.itemIndex = null;
                if(item) {
                    this.modal.title = 'Edit Creditor Code';
                    this.modal.data = Object.assign(this.modal.data, item);
                    this.modal.itemIndex = index;
                    this.loadCreditorCode();
                } else {
                    this.modal.title = 'Add Creditor Code';
                    this.modal.data = {
                        organization_id: this.organization_id,
                        coa_companie: null,
                        coa_companie_id: null,
                        creditor_code: null,
                        erp_mastercode_id: null,
                    }
                }
                
                this.modal.open = true;
            },
            confirmRemove(item, index) {
                this.modalDel.removeId    = item.id !== null ? item.id : null;
                this.modalDel.removeIndex = index;
                this.modalDel.open = true;
            },
            removeItem() {
                if(this.modalDel.removeId) this.modalDel.removeIds.push(this.modalDel.removeId);
                this.$delete(this.vendorLinkingCreditorCode, this.modalDel.removeIndex);
                this.$emit('updateRemoveIds', this.modalDel.removeIds);
                this.$emit('updateCreditorCodes', this.vendorLinkingCreditorCode);
                this.modalDel.open = false;
            },
            saveItem() {
                if(!this.modal.data.coa_companie) return this.$alertNotification("Finance company is required.", "danger");
                if(!this.modal.data.creditor_code) return this.$alertNotification("Creditor code is required.", "danger");

                const request = {
                    id: this.modal.data.id ? this.modal.data.id : null,
                    organization_id: this.organization_id,
                    coa_companie_id: this.modal.data.coa_companie.id,
                    erp_mastercode_id: this.modal.data.creditor_code.id,
                    coa_companie: {
                        id: this.modal.data.coa_companie.id,
                        name: this.modal.data.coa_companie.name,
                        code: this.modal.data.coa_companie.code
                    },
                    creditor_code: {
                        id: this.modal.data.creditor_code.id,
                        source_code: this.modal.data.creditor_code.source_code,
                        source_description: this.modal.data.creditor_code.source_description
                    }
                }

                let arrkExists = [];
                if(request.id || this.modal.itemIndex !== null) {
                    arrkExists = this.vendorLinkingCreditorCode.filter((item, index) => ((item.id != request.id || index != this.modal.itemIndex) && item.coa_companie_id == request.coa_companie_id));
                } else {
                    arrkExists = this.vendorLinkingCreditorCode.filter(item => (item.coa_companie_id == request.coa_companie_id));
                }
                
                if(arrkExists.length) return this.$alertNotification("Finance company is already exists.", "danger");
                if(request.id || this.modal.itemIndex !== null) {
                    this.vendorLinkingCreditorCode[this.modal.itemIndex] = Object.assign(this.vendorLinkingCreditorCode[this.modal.itemIndex], request);
                } else {
                    this.vendorLinkingCreditorCode.push(request);
                }

                this.modal.open = false;
                this.$emit('updateCreditorCodes', this.vendorLinkingCreditorCode);
            },
            changeFinanceCompany() {
                this.modal.data.creditor_code = null;
            }
        }
    }
</script>
